/**
 *
 * LabelValue
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { arrayToSentence } from 'utils/stringUtils';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import _classNames from 'classnames';
import HTMLContent from 'components/HTMLContent';
const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    overflow: 'hidden',
  },
  cardRoot: {
    justifyContent: 'center',
  },
  label: {
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.text.primary,
    ...theme.typography.pxSmall,
    '& a': {
      color: theme.palette.primary.main,
      display: 'initial',
      textDecoration: 'none',
      ...theme.typography.pxSmall,
      '&.normal-text': {
        color: `${theme.palette.text.primary} !important`,
        cursor: 'default',
        pointerEvents: 'none',
      },
      '&.no-label': {
        marginLeft: 0,
      },
    },
  },
  overline: {
    '& span': {
      ...theme.typography.overline,
    },
    '& a': {
      color: theme.palette.primary.main,
      display: 'initial',
      textDecoration: 'none',
      ...theme.typography.overline,
      '&.normal-text': {
        color: theme.palette.text.primary,
        cursor: 'default',
        pointerEvents: 'none',
      },
      '&.no-label': {
        marginLeft: 0,
      },
    },
  },
  tagLabel: {
    color: theme.palette.text.primary,
    fontSize: '12px !important',
    fontWeight: '400 !important',
    fontFamily: 'MadaRegular',
  },
});

// currently used only for book authors, refactor this when needed to re-use in some other parts
function LabelValue(props) {
  const { classes, label, value, type, isCard, overline } = props;
  if (_isEmpty(value)) return null;
  let finalValue = value;
  let LinksWithProperGrammar;
  if (typeof value === 'object' && !Array.isArray(value)) finalValue = [value];
  if (typeof value !== 'string' && typeof value !== 'undefined') {
    const HtmlAuthorLinks = finalValue.map(item => {
      const finalItem = _has(item, 'fields') ? item.fields : item;
      if (!_isEmpty(_get(finalItem, 'name'))) {
        const {
          name,
          slug,
          reviewStatus,
          mastersDegree = '',
          doctoralDegree = '',
        } = finalItem;
        let link = `/${type}/${slug}`;
        let normalText = false;
        if (reviewStatus !== 'Accepted') {
          link = '#';
          normalText = true;
        }
        return `<a href="${link}" class="value  ${normalText &&
          'normal-text'} ${!label && 'no-label'}">${name} ${mastersDegree ||
          ''} ${doctoralDegree || ''}</a>`;
      }
      return null;
    });
    if (_isEmpty(HtmlAuthorLinks) || HtmlAuthorLinks[0] === null) return null;
    LinksWithProperGrammar = arrayToSentence(HtmlAuthorLinks);
  }

  return (
    <div
      className={_classNames(
        classes.root,
        isCard ? classes.cardRoot : undefined,
      )}
    >
      <span
        className={_classNames({
          [classes.label]: true,
          [classes.overline]: overline,
        })}
      >
        {label && <span className={classes.tagLabel}>{`${label} `} </span>}

        {LinksWithProperGrammar ? (
          <HTMLContent content={LinksWithProperGrammar} />
        ) : (
          value
        )}
      </span>
    </div>
  );
}

LabelValue.propTypes = {
  classes: PropTypes.object,
  label: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
  isCard: PropTypes.bool,
  overline: PropTypes.bool,
};

LabelValue.defaultProps = {
  type: 'people',
  overline: false,
};
export default withStyles(styles)(LabelValue);
